import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { NgtChipComponent } from '@corporate/ng-tebis-base-components';
import { AIChatMessage, AIForm } from '../../../03_model/ai-chat-message.model';
import { AssistantService } from '../../../04_service/assistant/assistant.service';
import { AssistantMessageComponent } from "../assistant-message/assistant-message.component";

@Component({
  selector: 'tps-assistant-suggestions',
  imports: [
    NgtChipComponent,
    AssistantMessageComponent
],
  templateUrl: './assistant-suggestions.component.html',
  styleUrls: ['./assistant-suggestions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.disabled]': '!!selectedSuggestion()',
  }
})
export class AssistantSuggestionsComponent implements AIForm {

  assistantService = inject(AssistantService);

  data = input.required<{suggestions: string[], messageText?: string, selectedSuggestion?: string}>();
  update = input.required<(newData: any) => void>();

  suggestions = computed(() => this.data().suggestions);
  messageText = computed(() => this.data().messageText);
  selectedSuggestion = computed(() => this.data().selectedSuggestion);

  async onSelectSuggestion(suggestion: string) {
    if (this.selectedSuggestion()) {
      return;
    }

    this.update()({ ...this.data(), selectedSuggestion: suggestion });

    await this.assistantService.addMessage(<AIChatMessage>{
      type: 'standard',
      role: 'user',
      content: suggestion,
      requiresFollowUp: false,
    });

    await this.assistantService.addMessage(<AIChatMessage>{
      type: 'tool-response',
      role: 'user',
      content: `The user selected the suggestion: "${suggestion}"`,
      requiresFollowUp: true,
    });
  }

  isSuggestionSelected(suggestion: string): boolean {
    return this.selectedSuggestion() === suggestion;
  }
}
